export default "__VITE_ASSET__CkpFOE6z__"